import e from"./HitsPerPage.vue_vue&type=script&lang.js";import{render as t}from"./HitsPerPage.vue_vue&type=template&id=5d43db9c&lang.js";e.render=t;export default e;
//# sourceMappingURL=HitsPerPage.vue.js.map
